import React from 'react';
import { FaUserFriends } from 'react-icons/fa';

const PersonCount = ({ numPersons }) => {
    return (
        <div className="pt-5 pb-2">
            <h2 className="text-lg font-semibold">Number of Persons</h2>
            
            <div className="flex justify-between items-center mt-2 bg-gray-100 rounded-md p-3">
                <div className="w-5/6">
                    <p className="text-lg font-medium truncate">{numPersons}</p>
                    <p className="text-xs text-gray-600">Children over 5 are counted; the driver is excluded.</p>
                </div>
                
                <div className="w-10 h-10 flex items-center justify-center bg-gray-200 rounded-full">
                    <FaUserFriends className="text-gray-700 text-xl" />
                </div>
            </div>
        </div>
    );
};

export default PersonCount;
